// src/api/adminApi.ts
import axiosInstance from "./axiosInstance"; // Reusing your axios instance
import { AdminRequestPayload } from "../types/adminRequestPayload";  // Create a type for the request body

// POST function to send data to the backend for admin search
export const submitAdminApi = async (
  data: AdminRequestPayload
): Promise<any> => {
  try {
    const response = await axiosInstance.post(
      `/api/admin/admin-view?plantId=${data.plantId}&ioMaterialType=${data.ioMaterialType}`, // API endpoint with query params
      data // Body of the POST request
    );
    return response.data; // Return the server response
  } catch (error) {
    console.error("Error submitting admin search:", error);
    throw error; // Rethrow the error to be handled by calling code
  }
};

export const deleteAdminApi = async (
  data: AdminRequestPayload
): Promise<any> => {
  try {
    const response = await axiosInstance.post(
      `/api/admin/delete-approver`, // API endpoint with query params
      data // Body of the POST request
    );
    return ({ status: response.status, data: response.data }); // Return the server response
  } catch (error) {
    console.error("Error deleting admin :", error);
    throw error; // Rethrow the error to be handled by calling code
  }
};
